import { Injectable } from '@angular/core';
import { MyHivveAppClient } from '@hivvetech/myhivve-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectionService {
  constructor() {}

  async redirectToApp(app: MyHivveAppClient): Promise<Window> {
    return this.urlOpener(app.launchUrl);
  }

  redirectTo(url: string | null, params?: URLSearchParams | string): void {
    let redirectUrl = url;

    if (params) {
      redirectUrl = `${url}?${params}`;
    }

    return window.location.replace(`${redirectUrl}`);
  }

  urlOpener(url: string, target: string = '_self'): Promise<Window> {
    const windowProxy = window.open(url, target);
    if (windowProxy) {
      return Promise.resolve(windowProxy);
    } else {
      return Promise.reject();
    }
  }
}
